import React from 'react';
import moment from 'moment';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { DateFormats } from 'constants/common';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { formatCurrency } from 'utils';
import { CustomerVendorOpportunity } from '@trnsact/trnsact-shared-types';

interface Props {
  customerOpportunities: CustomerVendorOpportunity[];
}

export const ActiveOpportunitiesCard = ({ customerOpportunities }: Props) => {
  return (
    <CardContainer title="Opportunities">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Sales Rep</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customerOpportunities?.map(o => (
            <TableRow key={o.vendorOpportunityId}>
              <TableCell>{moment(o.createdDateTime).format(DateFormats.DateTimeShort12Hour)}</TableCell>
              <TableCell>{o.salesRepresentative?.fullName}</TableCell>
              <TableCell>{formatCurrency(o.invoiceTotal)}</TableCell>
              <TableCell>{o.transactionStage}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContainer>
  );
};
